import { IFormSchema, fieldOptionsFactory } from "spark-forms";
import { DateResolution, FreezePeriod, GlimmerConfiguration, GridType, UserType } from "../../../../../../../api/generated/data-contracts";
import { DropdownOptionEx } from "../../../../../../../Utilities/DropdownOptionEx";
import { EntityFieldSelector } from "../../../../../../../forms/_builders/new/components/EntityFieldSelector";
import { resourceSchema } from "../../../../../../../forms/resource/resourceSchema";
import { projectSchema } from "../../../../../../../forms/project/projectSchema";
import { settings } from "../../../../../../../context/network/http/QueryProvider/queries/UISettings";
import { translate } from "../../../../../../../Locales/i18n/localizationService";

export const glimmerConfigurationSchema = () : IFormSchema<GlimmerConfiguration> => ({
	fields: {
		userTypes: fieldOptionsFactory.predefinedArray({
			displayName: translate.t("Common.Roles"),
			config: {
				predefinedOptions: { options: DropdownOptionEx.enumToDropdownOptions<UserType>(UserType) }
			}
		}),
		gridTypes: fieldOptionsFactory.predefinedArray({
			displayName: translate.t("Common.Views"),
			config: {
				predefinedOptions: { options: DropdownOptionEx.enumValuesToDropdownOptions<GridType>(GridType, [1,2]) }
			}
		})
	}
});

export const pickerFieldsSchema = (type: 'resource' | 'project') : IFormSchema<any> => ({
	fields: {
		title: fieldOptionsFactory.customComponent({
			displayName: translate.t("PickerFields.ItemTitle"),
			config: {
				component: EntityFieldSelector,
				schema: () => type === 'resource' ? resourceSchema : projectSchema,
				customProperties: () => type === 'resource' ? settings().resourceCustomProperties : settings().projectCustomProperties,
				multiSelect: false,
				propertyTypes: 'both',
			}
		}),
		secondary: fieldOptionsFactory.customComponent({
			displayName: translate.t("PickerFields.ItemSecondaryText"),
			config: {
				component: EntityFieldSelector,
				schema: () => type === 'resource' ? resourceSchema : projectSchema,
				customProperties: () => type === 'resource' ? settings().resourceCustomProperties : settings().projectCustomProperties,
				multiSelect: false,
				propertyTypes: 'both',
			}
		}),
		tertiary: fieldOptionsFactory.customComponent({
			displayName: translate.t("PickerFields.ItemTertiaryText"),
			config: {
				component: EntityFieldSelector,
				schema: () => type === 'resource' ? resourceSchema : projectSchema,
				customProperties: () => type === 'resource' ? settings().resourceCustomProperties : settings().projectCustomProperties,
				multiSelect: false,
				propertyTypes: 'both',
			}
		}),
		iconOverride: fieldOptionsFactory.customComponent({
			displayName: translate.t("PickerFields.ItemIconText"),
			config: {
				component: EntityFieldSelector,
				schema: () => type === 'resource' ? resourceSchema : projectSchema,
				customProperties: () => type === 'resource' ? settings().resourceCustomProperties : settings().projectCustomProperties,
				multiSelect: false,
				propertyTypes: 'both',
			}
		})
	}
});

export const freezePeriodSchema = () : IFormSchema<FreezePeriod> => ({
	fields: {
		resolution: fieldOptionsFactory.predefinedArray({
			displayName: translate.t("Common.Resolution"),
			hide: item => item.freezeBeforeTodayOnly,
			config: {
				predefinedOptions: { options: DropdownOptionEx.enumToDropdownOptions<DateResolution>(DateResolution) }
			}
		}),
		number: fieldOptionsFactory.number({
			displayName: translate.t("FreezePeriodEditor.Number"),
			hide: item => item.freezeBeforeTodayOnly,
		}),
		freezeBeforeTodayOnly: fieldOptionsFactory.boolean({
			displayName: translate.t("FreezePeriodEditor.FreezePrevious")
		})
	}
});